'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ReactNode, useState } from 'react';
import { IntlProvider } from 'react-intl';

import { AppLanguage } from '@/features/i18n/AppLanguage';
import { I18nConfig } from '@/features/i18n/getI18nConfig';
import { AppThemeProvider } from '@/theme/AppThemeProvider';
type Props = {
  i18nConfig: I18nConfig;
  children: ReactNode;
};


export const AppProviders = ({ children, i18nConfig }: Props) => {
  const [queryClient] = useState(() => new QueryClient());


  return (
    <QueryClientProvider client={queryClient}>
      <IntlProvider
        {...i18nConfig}
         defaultLocale={AppLanguage.German}
        wrapRichTextChunksInFragment={true}
      >

        <AppThemeProvider>{children}</AppThemeProvider>

        <ReactQueryDevtools initialIsOpen={false} />
      </IntlProvider>
    </QueryClientProvider>
  );
};
